import { createSelector } from 'reselect';
import { prop } from 'ramda';

const selectLocalesDomain = prop('locales');

export const selectLocalesLanguage = createSelector(
  selectLocalesDomain,
  prop('language')
);
